export default __webpack_public_path__ + "static/media/uv11_en_jing_b3.e66c6dd1.mp3";